import { styled } from 'styled-components';

export const OverseasCard = styled.section`
  position: relative;
  background-color: #fff;
  @supports (contain-intrinsic-height: 184px) {
    content-visibility: auto;
    contain-intrinsic-height: 184px;
  }
  &:before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    width: calc(100% - 20px);
    height: 1px;
    background-color: #efefef;
    z-index: 0;
  }
  &:last-child {
    &:before {
      display: none;
    }
  }
`;

export const MainCard = styled.section`
  @supports (contain-intrinsic-height: 184px) {
    content-visibility: auto;
    contain-intrinsic-height: 184px;
  }
  position: relative;
  background-color: #fbfcff;
`;

export const MoreChannelWrapper = styled.div`
  border-top: 1px dotted #d9d9d9;
  background-color: #f3f9fd;
  .more-channel-item {
    &:hover {
      box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.08);
    }
    @supports (contain-intrinsic-height: 184px) {
      content-visibility: auto;
      contain-intrinsic-height: 184px;
    }
  }
  .more-channel-item:nth-last-child(2):hover {
    box-shadow: none; /* 移除悬停时的阴影 */
  }
  .more-channel-item + .more-channel-item {
    border-top: 1px dotted #d9d9d9;
  }
`;
